var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({background: _vm.config.background}),attrs:{"id":"app"}},[(!_vm.loading.config)?_c('router-view'):_vm._e(),(_vm.noPermission && !_vm.isLogin)?_c('div',{staticClass:"noPermission"},[_c('logo'),_c('user-nav')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }